import Vue from 'vue';
export default Vue.component('ed-disclamer', { name: 'ed-disclamer'});